// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse.attributeTypeMap;
    }
}
ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse.discriminator = undefined;
ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse.additionalProperties = false;
ClaimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1TypesPaymentMethodTypesCodePaymentMethodTypesResponse.js.map